import { Component } from '@angular/core';

@Component({
  standalone: false,
  selector: 'svg-icons',
  templateUrl: './svg-icons.component.html',
})
export class SvgIconsComponent {}
